<template>
  <div class="iv-appraising-declare iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <Tab v-model="tabName" :navList="navList" @on-click="tabClick"></Tab>
      <List
        v-if="list.length"
        :showPage="true" 
        :map="map" 
        :total="total" 
        :list="list"
        :current="currentPage"
        :pageSize="pageSize"
        class="iv-m-t-24" 
        @on-detail="detailPage" 
        @on-change="changePage"
        @on-page-size-change="changePageSize">
      </List>
      <NoData v-if="!list.length"></NoData>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import Tab from '@/components/tab'
import NoData from '@/components/no-data'
import List from '@/components/declare-list'
import { listApplication } from './interface'

export default {
  data () {
    return {
      list: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      infoState: 'SBZT02',
      paramsKey: 'infoState',
      spinShow: false,
      tabName: 'SBZT02'
    }
  },
  created () {
    this.map = {
      title: 'applicationName',
      orgName: 'publishOrgName',
      publishDate: 'publishTime',
      endDate: 'applicationDeadline'
    }
    this.currentPage = this.$route.query.currentPage
    this.initTabs()
    this.tabName = this.$route.query.tabName || 'SBZT02'
    this.tabClick(this.tabName, 'create')
  },
  methods: {
    detailPage (item) {
      let type = 'edit'
      // item.isReportState === false || 
      if (this.infoState == 'SBZT04' || this.paramsKey == 'isAward') {
        type = 'see'
      }
      this.$router.push({
        name: 'appraisingDetail',
        query: {
          applicationInfoId: this.$encode(item.applicationInfoId),
          type: this.$encode(type),
          bizLineCode: this.$encode(item.bizLineCode),
          isSignUp: this.tabName === 'signup',
          currentPage: this.currentPage,
          tabName: this.tabName
        }
      })
    },
    initTabs () {
      this.navList = [{
        label: '进行中',
        name: 'SBZT02'
      }, {
        label: '已结束',
        name: 'SBZT04'
      }, {
        label: '已报名',
        name: 'signup'
      }, {
        label: '已获奖',
        name: 'getPrize'
      }]
    },
    tabClick (name, type) {
      if (name == 'SBZT02' || name == 'SBZT04') {
        this.paramsKey = 'infoState'
        this.infoState = name
      } else if (name == 'signup') {
        this.paramsKey = 'isReport'
        this.infoState = true
      } else {
        this.paramsKey = 'isAward'
        this.infoState = true
      }
      this.tabName = name
      if (!type) {
        this.currentPage = 1
      }
      this.getAppraisingList()
    },
    //获取评优列表
    getAppraisingList () {
      this.spinShow = true
      this.list = []
      listApplication({
        bizTypeCode: 'YWLX01',
        [this.paramsKey]: this.infoState,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }).then((data) => {
        this.list = data.data
        this.total = data.count
        this.spinShow = false
      })
    },
    changePage (page) {
      this.currentPage = page
      this.getAppraisingList()
    },
    changePageSize (page) {
      this.pageSize = page
      this.getAppraisingList()
    }
  },
  components: {
    Tab,
    List,
    NoData
  }
}
</script>

<style lang="scss" scoped>
.iv-appraising-declare {
  min-height: 100%;
  background-color: #fff;
}
</style>
